export default "__VITE_ASSET__$Ue8hNDg__"